import React, { forwardRef, ReactNode } from "react";
import { Controller, useFormContext } from "react-hook-form";
import RHFDownshift from "./RHFDownshift";
import RHFDownshiftMulti from "./RHFDownshiftMulti";

export const InputBaseStyle = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
    (props, ref) => {
        const { className, ...others } = { ...props }
        return (
            <input
                ref={ref}
                className="w-full px-2 py-1  border border-gray-2000 rounded-md focus:outline-ab-lightgreen focus:border-gray-2100 disabled:bg-gray-200"
                {...others}
            />
        )
    }
)

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: ReactNode
    containerClass?: string
    help?: ReactNode | JSX.Element
    icon?: JSX.Element
}

export interface InputDropdownSingleProps extends InputProps {
    options: [];
}

export interface InputDropdownMultiProps extends InputProps {
    options: [];
}


export const InputBaseText = forwardRef<HTMLInputElement, InputProps>(
    (props, ref) => {
        const {
            containerClass = "",
            label = undefined,
            icon = <></>,
            className = "",
            help = "",
            ...others
        } = { ...props }
        return (
            <div className={`flex flex-col justify-start items-start gap-2 w-full ${containerClass}`}>
                {
                    label && (
                        <label className="text-left text-base text-gray font-medium">
                            {label}
                        </label>
                    )
                }
                <div className="flex items-center gap-4 w-full">
                    {icon}
                    <InputBaseStyle {...others} ref={ref} className={className} />
                </div>
                {help && <InputHelp>{help}</InputHelp>}
            </div>
        )
    }
)

export interface InputDropdownSingleRowProps {
    id: string;
    label: string;
}

export const InputDropdownSingle = forwardRef<HTMLInputElement, InputDropdownSingleProps>(
    (props, ref) => {
        const {
            containerClass = "",
            label = undefined,
            className = "",
            name = "",
            help = "",
            options = []
        } = { ...props }

        const { control } = useFormContext()

        return (
            <Controller
                name={name}
                control={control}
                render={({ field }) => {
                    return (<RHFDownshift
                        options={options}
                        onChange={field.onChange}
                        value={field.value}
                        help={help}
                        label={label}
                        className={className}
                        containerClass={containerClass}
                    />)
                }}
            />
        )
    }
)

export const InputDropdownMulti = forwardRef<HTMLInputElement, InputDropdownSingleProps>(
    (props, ref) => {
        const {
            containerClass = "",
            label = undefined,
            className = "",
            name = "",
            help = "",
            options = []
        } = { ...props }

        const { control } = useFormContext()

        return (
            <Controller
                name={name}
                control={control}
                render={({ field }) => {
                    return (<RHFDownshiftMulti
                        options={options}
                        onChange={field.onChange}
                        value={field.value}
                        help={help}
                        label={label}
                        className={className}
                        containerClass={containerClass}
                    />)
                }}
            />
        )
    }
)

export const InputHelp = ({ children }: any) => {
    return <p className="text-gray-600 text-sm">{children}</p>
}